import React, { memo } from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { ADMIN_COLORS } from '@/constants/admin';
import { AnchorRect } from '@/hooks/common/useAnchoredPosition';
import { CreateEventFormData, CreateEventFormErrors } from '@/types/admin/createEvent';
import { DateTimePickerButton } from '@/components';

interface DateTimeSectionProps {
  formData: CreateEventFormData;
  errors: CreateEventFormErrors;
  onStartTimePress: (anchor?: AnchorRect) => void;
  onEndTimePress: (anchor?: AnchorRect) => void;
}

export const DateTimeSection = memo<DateTimeSectionProps>(({
  formData,
  errors,
  onStartTimePress,
  onEndTimePress,
}) => {
  return (
    <View style={styles.section}>
      <Text style={styles.sectionTitle}>Date & Time</Text>
      
      <DateTimePickerButton
        label="Start Time *"
        value={formData.startTime}
        onPress={onStartTimePress}
        error={errors.startTime}
      />

      <DateTimePickerButton
        label="End Time *"
        value={formData.endTime}
        onPress={onEndTimePress}
        error={errors.endTime}
      />
    </View>
  );
});

DateTimeSection.displayName = 'DateTimeSection';

const styles = StyleSheet.create({
  section: {
    marginBottom: 24,
  },
  sectionTitle: {
    fontSize: 18,
    fontWeight: '600',
    color: ADMIN_COLORS.TEXT_PRIMARY,
    marginBottom: 16,
  },
});
